import { isDefined, mergeDeep } from "@perxis-auto/shared";
function localeMiddleware({ localeId }) {
  return async function* closedMiddleware(call, options) {
    const { request } = call;
    if (isDefined(localeId)) {
      Object.assign(request, {
        options: mergeDeep(request.options || {}, {
          localeId
        })
      });
    }
    const response = yield* call.next(call.request, options);
    return response;
  };
}
export {
  localeMiddleware
};
